import { FC } from 'react';
import { IListCheckCandidate } from 'src/ts/interfaces/listCheck';
import {
  ListCheckException,
  ListCheckNote,
  ListCheckNoteLabel,
  ListCheckNoteMeta,
  ListCheckRowNote
} from '../../styles';
import { listCheckCopy } from './listCheckCopy';
import NoteBlock from './NoteBlock';

type MetaProps = { action?: string | null; field: string | null };
type CandidateNotesProps = { candidate: IListCheckCandidate };

const Meta: FC<MetaProps> = ({ action, field }) => {
  const text = [action && `Action: ${action}`, field && `Field: ${field}`]
    .filter(Boolean)
    .join(' · ');

  return text ? <ListCheckNoteMeta>{text}</ListCheckNoteMeta> : null;
};

const CandidateNotes: FC<CandidateNotesProps> = ({ candidate }) => {
  const { exception, list_note } = candidate;
  const notes = candidate.notes ?? [];

  return (
    <>
      {exception && (
        <ListCheckException
          data-testid="list-check-exception"
          role="note"
          aria-label={listCheckCopy.rulingException}
        >
          <ListCheckNoteLabel>{listCheckCopy.rulingException}</ListCheckNoteLabel>
          <Meta action={exception.action} field={exception.field} />
          {exception.body}
        </ListCheckException>
      )}
      <NoteBlock text={list_note} />
      {notes.length > 0 && (
        <ListCheckNote data-testid="list-check-row-notes">
          <ListCheckNoteLabel>{listCheckCopy.rowNotes}</ListCheckNoteLabel>
          {notes.map((note, index) => (
            <ListCheckRowNote key={index} data-testid="list-check-row-note">
              <Meta field={note.field} />
              {note.body}
            </ListCheckRowNote>
          ))}
        </ListCheckNote>
      )}
    </>
  );
};

export default CandidateNotes;
